import { BankConnectionsCard, bankConnections } from "./BankConnectionsCard";

/**
 * Read tools whose result shows as a card under the tool's line (a lookup the user asked to see),
 * by tool name. Each parses the result it was given and renders nothing it can't read.
 */
const RESULT_CARDS: Partial<Record<string, (result: unknown) => JSX.Element | null>> = {
  list_bank_connections: (result) => {
    const connections = bankConnections(result);
    return connections && <BankConnectionsCard connections={connections} />;
  },
};

/** The card a tool's result shows, or null: the tool has none, or the result isn't its shape. */
export function resultCard(toolName: string, result: unknown): JSX.Element | null {
  const render = RESULT_CARDS[toolName];
  return render && result !== undefined ? render(result) : null;
}
